import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { NotificationRow } from '@models/notification';
import dayjs from 'dayjs';

import useNotificationClick from './hooks/useNotificationClick';
import styles from './styles.module.scss';

interface Props {
    notification: NotificationRow
}

function NotificationItem({ notification }:Props) {
    const {
        readAt, title, createdAt, body,
    } = notification;
    const onClick = useNotificationClick(notification);
    return (<Column fullWidth
        className={`${styles.item} ${readAt && styles.read}`}
        onClick={onClick}
        spacing={4} >
        <Row fullWidth
            justify='space-between'
            align='center' >
            <Text size='s'
                color='#464B50' >
                {title}
            </Text>
            <Text size='s'
                color='#464B50' >
                {createdAt ? dayjs(createdAt).format('YYYY.MM.DD. HH:mm') : '-'}
            </Text>
        </Row>
        <Text size='s' className={styles.content}>{body}</Text>
    </Column>);
}

export default NotificationItem;
